import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import PrivacyPolicy from "../components/policiesPage/PrivacyPolicy";
import Impressum from "../components/policiesPage/Impressum";

function PoliciesPage() {
  return (
    <TailwindPageWrapper>
      <PrivacyPolicy />
      <Impressum />
    </TailwindPageWrapper>
  );
}

export default PoliciesPage;
